import React from 'react';
import Google2FAModal from '@/components/Google2FAModal';
import type { AppInitialState } from '../types';
import { useGoogle2FA } from '../hooks/useGoogle2FA';

interface Google2FAModalWrapperProps {
    initialState: AppInitialState;
    setInitialState: (state: AppInitialState | ((prev: AppInitialState) => AppInitialState)) => void;
}

const Google2FAModalWrapper: React.FC<Google2FAModalWrapperProps> = ({
    initialState,
    setInitialState,
}) => {
    const [google2FAModalVisible, google2FAHandlers] = useGoogle2FA(initialState, setInitialState);

    return (
        <Google2FAModal
            visible={google2FAModalVisible}
            onCancel={google2FAHandlers.onCancel}
            onSuccess={google2FAHandlers.onSuccess}
        />
    );
};

export default Google2FAModalWrapper;
